import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/skin-kristal.css';
import { SkinProvider } from './context/SkinContext';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SkinProvider>
    <App />
  </SkinProvider>
);
